import { useEffect, useState } from "react";

const KEY = "stax-cursor";
const EVENT = "stax-cursor-change";

export const getCursorOn = () => {
  try {
    return localStorage.getItem(KEY) !== "off";
  } catch {
    return true;
  }
};

export const setCursorOn = (on) => {
  try {
    localStorage.setItem(KEY, on ? "on" : "off");
  } catch {}
  window.dispatchEvent(new CustomEvent(EVENT, { detail: on }));
};

export const useCursorOn = () => {
  const [on, setOn] = useState(getCursorOn);
  useEffect(() => {
    const handler = (e) => setOn(e.detail);
    window.addEventListener(EVENT, handler);
    return () => window.removeEventListener(EVENT, handler);
  }, []);
  return on;
};
